/**
*	Site-specific configuration settings for Highslide JS
*/
hs.graphicsDir = 'http://cdn.shopify.com/s/files/1/0153/1977/t/5/assets';
hs.outlinesDir = '/';
hs.showCredits = false;
hs.outlineType = 'custom';
hs.fadeInOut = true;
hs.allowMultipleInstances = false;
hs.enableKeyListener = false;
hs.registerOverlay({
	html: '<div class="close-simple-white" onclick="return hs.close(this)" title="Close"></div>',
	position: 'top right',
	useOnHtml: true,
	fade: 2 // fading the semi-transparent overlay looks bad in IE
});
hs.align = 'center';
